import {createEntityAdapter} from '@reduxjs/toolkit'
import {ISpendingType} from '../../types'

export const spendingTypesAdapter = createEntityAdapter<ISpendingType>()